import {
  REQUEST_LISTINGS,
  SET_LISTINGS,
  SET_KECLOAK_TOKEN,
  REQUEST_GET_LAWYER_NOTIFICATIONS,
  REQUEST_GET_MANAGER_NOTIFICATIONS,
  SET_LAWYER_NOTIFICATIONS,
  SET_MANAGER_NOTIFICATIONS,
  SET_CURRENT_INSTANCE_TAB,
  REQUEST_READ_LAWYER_NOTIFICATION,
  REQUEST_READ_MANAGER_NOTIFICATION,
  REQUEST_LISTINGS_INTERVENANTS,
  SET_LISTINGS_INTERVENANTS,
  REQUEST_LINK_BENEFICIARY_CODES,
  SET_LINK_BENEFICIARY_CODES,
  REQUEST_GET_EXPERT_NOTIFICATIONS,
  SET_EXPERT_NOTIFICATIONS,
  REQUEST_READ_EXPERT_NOTIFICATION,
  REQUEST_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM,
  SET_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM,
  SET_CLAIM_NUMBER,
  SET_NOTIFICATION,
  SET_OPEN_UNLOCK_CLAIM_DIALOG,
  REQUEST_FORCE_UNLOCK_CLAIM,
  SET_CURRENT_INDEX_TAB_MANAGER,
  SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_MANAGER,
  SET_CURRENT_INDEX_GLOBAL_TAB_MANAGER,
  SET_NOTIFICATION_FEE_NOTE,
  REQUEST_READ_CONVERT_CLAIM_NOTIFICATION,
  REQUEST_REFRESH_MANAGER,
  SET_NOTIFICATIONS_INBOXES,
  REQUEST_GET_NOTIFICATIONS_INBOXES,
  SET_CURRENT_INDEX_TAB_EXPERTISE,
  REQUEST_GET_COUNT_NOTIFICATIONS_MANAGER,
  REQUEST_SET_COUNT_NOTIFICATIONS_MANAGER,
  RESET_INDEX_TABS,
  SET_CURRENT_INDEX_TAB_TRANSACTION,
  SET_TRANSACTION_ID,
  SET_CURRENT_REGULATION_PATH,
  REQUEST_GET_INBOXES_LAWYER_NOTIFICATIONS,
  SET_INBOXES_LAWYER_NOTIFICATIONS,
  REQUEST_GET_COUNT_INBOXES_LAWYER_NOTIFICATIONS,
  SET_COUNT_INBOXES_LAWYER_NOTIFICATIONS,
  SET_CURRENT_INDEX_GLOBAL_TAB_LAWYER,
  SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_LAWYER,
  SET_CURRENT_INDEX_TAB_LAWYER,
} from 'containers/AppContainer/constants';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';

export const requestListings = () => ({
  type: REQUEST_LISTINGS,
});

export const setListings = (listings: Listings) => ({
  type: SET_LISTINGS,
  listings,
});

export const requestIntervenants = () => ({
  type: REQUEST_LISTINGS_INTERVENANTS,
});

export const setIntervenants = (intervenants: SagisConfig[]) => ({
  type: SET_LISTINGS_INTERVENANTS,
  intervenants,
});

export const requestGetLawyerNotifications = () => ({
  type: REQUEST_GET_LAWYER_NOTIFICATIONS,
});

export const setLawyerNotifications = (lawyerNotifications: any) => ({
  type: SET_LAWYER_NOTIFICATIONS,
  lawyerNotifications,
});

export const requestReadLawyerNotification = (id: number) => ({
  type: REQUEST_READ_LAWYER_NOTIFICATION,
  id,
});

export const requestReadManagerNotification = (payload: any) => ({
  type: REQUEST_READ_MANAGER_NOTIFICATION,
  payload,
});

export const requestGetManagerNotifications = (payload: number) => ({
  type: REQUEST_GET_MANAGER_NOTIFICATIONS,
  payload,
});

export const setManagerNotifications = (managerNotifications: any) => ({
  type: SET_MANAGER_NOTIFICATIONS,
  managerNotifications,
});

export const setKeycloakToken = (token: string) => ({
  type: SET_KECLOAK_TOKEN,
  token,
});
export const setCurrentInstanceTab = (index: string) => ({
  type: SET_CURRENT_INSTANCE_TAB,
  index,
});

export const requestLinkToBeneficiaryCodes = () => ({
  type: REQUEST_LINK_BENEFICIARY_CODES,
});

export const setLinkToBeneficiaryCodes = (
  linkToBeneficiaryCodes: SagisConfig[],
) => ({
  type: SET_LINK_BENEFICIARY_CODES,
  linkToBeneficiaryCodes,
});
export const requestGetExpertNotifications = () => ({
  type: REQUEST_GET_EXPERT_NOTIFICATIONS,
});
export const setExpertNotifications = (expertNotifications: any) => ({
  type: SET_EXPERT_NOTIFICATIONS,
  expertNotifications,
});

export const requestReadExpertNotification = (id: number) => ({
  type: REQUEST_READ_EXPERT_NOTIFICATION,
  id,
});

export const requestNotificationOpeningManagerMixedClaim = () => ({
  type: REQUEST_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM,
});

export const setNotificationOpeningManagerMixedClaim = (payload: {
  mixedClaims: [];
}) => ({
  type: SET_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM,
  mixedClaims: payload.mixedClaims,
});
export const setClaimNumber = (payload: any) => ({
  type: SET_CLAIM_NUMBER,
  payload,
});
export const setNotification = (payload: any) => ({
  type: SET_NOTIFICATION,
  payload,
});
export const requestOpenLockClaimDialog = (payload: any) => ({
  type: SET_OPEN_UNLOCK_CLAIM_DIALOG,
  payload,
});
export const requestForceUnlockClaim = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_FORCE_UNLOCK_CLAIM,
  payload,
  successCallBack,
});
export const setCurrentIndexTabManager = (payload: any) => ({
  type: SET_CURRENT_INDEX_TAB_MANAGER,
  payload,
});

export const setCurrentIndexTabJudiciaryProcessManager = (payload: any) => ({
  type: SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_MANAGER,
  payload,
});

export const setCurrentIndexGlobalTabManager = (payload: any) => ({
  type: SET_CURRENT_INDEX_GLOBAL_TAB_MANAGER,
  payload,
});

export const setNotificationFeeNote = (payload: any) => ({
  type: SET_NOTIFICATION_FEE_NOTE,
  payload,
});

export const requestReadConvertClaimNotification = (payload: any) => ({
  type: REQUEST_READ_CONVERT_CLAIM_NOTIFICATION,
  payload,
});

export const requestRefreshManager = (successCallBack: Function) => ({
  type: REQUEST_REFRESH_MANAGER,
  successCallBack,
});

export const requestGetNotificationsInboxes = (payload: any) => ({
  type: REQUEST_GET_NOTIFICATIONS_INBOXES,
  payload,
});

export const setNotificationsInboxes = (payload: any) => ({
  type: SET_NOTIFICATIONS_INBOXES,
  payload,
});
export const setCurrentIndexTabExpertise = (payload: any) => ({
  type: SET_CURRENT_INDEX_TAB_EXPERTISE,
  payload,
});

export const requestGetCountNotificationsInboxes = (payload: any) => ({
  type: REQUEST_GET_COUNT_NOTIFICATIONS_MANAGER,
  payload,
});
export const setCountNotificationsManager = (payload: any) => ({
  type: REQUEST_SET_COUNT_NOTIFICATIONS_MANAGER,
  payload,
});

export const resetTabsIndex = () => ({
  type: RESET_INDEX_TABS,
});

export const setCurrentIndexTabTransaction = (payload: any) => ({
  type: SET_CURRENT_INDEX_TAB_TRANSACTION,
  payload,
});

export const setTransactionId = (payload: any) => {
  return {
    type: SET_TRANSACTION_ID,
    payload,
  };
};

export const setCurrentRegulationPath = (payload: any) => {
  return {
    type: SET_CURRENT_REGULATION_PATH,
    payload,
  };
};

export const requestGetInboxesLawyerNotifications = () => ({
  type: REQUEST_GET_INBOXES_LAWYER_NOTIFICATIONS,
});

export const setInboxesLawyerNotifications = (
  inboxesLawyerNotifications: any,
) => ({
  type: SET_INBOXES_LAWYER_NOTIFICATIONS,
  inboxesLawyerNotifications,
});

export const requestGetCountInboxesLawyerNotifications = () => ({
  type: REQUEST_GET_COUNT_INBOXES_LAWYER_NOTIFICATIONS,
});

export const setCountInboxesLawyerNotifications = (
  countInboxesLawyerNotifications: any,
) => ({
  type: SET_COUNT_INBOXES_LAWYER_NOTIFICATIONS,
  countInboxesLawyerNotifications,
});

export const setCurrentIndexGlobalTabLawyer = (payload: any) => ({
  type: SET_CURRENT_INDEX_GLOBAL_TAB_LAWYER,
  payload,
});

export const setCurrentIndexTabJudiciaryProcessLawyer = (payload: any) => ({
  type: SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_LAWYER,
  payload,
});

export const setCurrentIndexTabLawyer = (payload: any) => ({
  type: SET_CURRENT_INDEX_TAB_LAWYER,
  payload,
});
